import { createContext, useContext } from 'react';
import type { CheckoutError } from '../services/checkout/checkout.types.ts';

export type AddErrorFunctionOptions = {
  message?: string,
  category?: string,
  tag?: string,
  severity?: 'error' | 'warning' | 'info' | 'success',
  variant?: 'outlined' | 'filled' | 'standard',
  title?: string,
  timeout?: number,
};

export interface DisplayableError {
  id: string;
  message: string;
  name?: string;
  details?: any;
  timestamp: number;
  error: Error;
  options: AddErrorFunctionOptions;
}

export type AddErrorFunction = (error: CheckoutError | Error, options?: AddErrorFunctionOptions) => void

export type DismissErrorFunction = (idOrError: string | Error | DisplayableError | AddErrorFunctionOptions) => void;

export interface ErrorContextType {
  addError: AddErrorFunction;
  dismissError: DismissErrorFunction;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const useErrorAlerts = (): ErrorContextType => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useErrorAlerts must be used within an ErrorProvider');
  }
  return context;
};

export default ErrorContext;